module.exports = __webpack_public_path__ + "fonts/ionicons.68e3a4f.eot";